import React from 'react';
import { Image, StyleSheet, TouchableOpacity } from 'react-native';

function TrailingIcon({ source, onPress, style }) {
  return (
    <TouchableOpacity onPress={onPress} style={style}>
      <Image source={source} style={styles.icon} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  icon: {
    width: 23,
    height: 23,
  },
});

export default TrailingIcon;
